import { BeatLoader } from './BeatLoader';
import { BEAT_PATTERNS } from '../../../src/constants/danceLoaders';

// 1-2-3-tap: even beats, "tap" styled distinctly
export function BachataLoader() {
  return <BeatLoader pattern={BEAT_PATTERNS.bachata} />;
}
